import { useState } from 'react'
import { useAuth } from '../hooks/useAuth'
import LoadingSpinner from './LoadingSpinner'
import './LogoutButton.css'

interface LogoutButtonProps {
  className?: string
  variant?: 'primary' | 'secondary' | 'outline'
  size?: 'small' | 'medium' | 'large'
  showIcon?: boolean
}

const LogoutButton = ({ 
  className = '', 
  variant = 'secondary',
  size = 'medium',
  showIcon = true 
}: LogoutButtonProps) => {
  const { logout, isAuthenticated } = useAuth()
  const [isLoggingOut, setIsLoggingOut] = useState(false)

  const handleLogout = async () => {
    try {
      setIsLoggingOut(true)
      await logout()
    } catch (err) {
      console.error('Logout error:', err)
      // Could show toast notification here
    } finally {
      setIsLoggingOut(false)
    }
  }

  // Only render the button if user is authenticated
  if (!isAuthenticated) {
    return null
  }

  return (
    <button
      onClick={handleLogout}
      disabled={isLoggingOut}
      className={`logout-button logout-button--${variant} logout-button--${size} ${className}`}
      aria-label="Sign out of your account"
    >
      {isLoggingOut ? (
        <LoadingSpinner size="small" />
      ) : (
        <>
          {showIcon && (
            <span className="logout-button__icon" aria-hidden="true">
              🚪
            </span>
          )}
          <span className="logout-button__text">
            {isLoggingOut ? 'Signing out...' : 'Sign Out'}
          </span>
        </>
      )}
    </button>
  )
}

export default LogoutButton 